import { render, staticRenderFns } from "./DeliveryAndWithdrawNotesTable.vue?vue&type=template&id=2d87a3f8&scoped=true"
import script from "./DeliveryAndWithdrawNotesTable.vue?vue&type=script&lang=js"
export * from "./DeliveryAndWithdrawNotesTable.vue?vue&type=script&lang=js"
import style0 from "./DeliveryAndWithdrawNotesTable.vue?vue&type=style&index=0&id=2d87a3f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d87a3f8",
  null
  
)

export default component.exports